// X173路数据
export const data_173 = {
  loadSceneId: '3423589610184896',
  mainTitle: '达川区 X173 陈家乡至渠县界公路(龙会乡至渠县界段)',  // 新增字段
  loadingModel: [
    {
      Id: '100031110081',
      project: '',
      location: { lat: 31.1310597, lon: 107.1971763, alt: 1 },
      viewToken: ''
    },
    {
      Id: '100031109687',
      project: '',
      location: { lat: 31.1310597, lon: 107.1971763, alt: 1 },
      viewToken: ''
    }
  ],
  projectStats: {
    constructionContent: '6.275km     km三、四级公路提升改造',
    budgetAmount: '4922.6',
    plannedDuration: '365',
    totalMaterialIn进场: '95次',
    todayMaterialIn进场: '0次'
  },
  markerLocations: [
    {
      name: 'LK+000-LK1+020',
      lat: 31.130086,
      lon: 107.192500,
      alt: 1,
      imgUrl: require('../png/黄.png'),
      color: '#FFD700',
      id: '544',
      status: 'yellow',
      subgradeEarthwork: 'yellow',
      subgradeSupport: 'yellow',
      subgradeBridge: 'yellow',
      subgradeDrainage: 'yellow',
      bridge: 'red',
      trafficSafety: 'red',
      fileList: [],
      worldposition: { x: -383.75, y: -47.78, z: 1 }
    },
    {
      name: 'K0+000-K2+600',
      lat: 31.121231,
      lon: 107.197664,
      alt: 1,
      imgUrl: require('../png/黄.png'),
      color: '#FFD700',
      id: '19301',
      status: 'yellow',
      subgradeEarthwork: 'yellow',
      subgradeSupport: 'yellow',
      subgradeBridge: 'yellow',
      subgradeDrainage: 'yellow',
      bridge: 'red',
      trafficSafety: 'red',
      fileList: [],
      worldposition: { x: -8.89, y: -2081.56, z: 1 }
    },
    {
      name: 'K2+600-K5+255',
      lat: 31.107641,
      lon: 107.204014,
      alt: 1,
      imgUrl: require('../png/黄.png'),
      color: '#FFD700',
      id: '19605',
      status: 'yellow',
      subgradeEarthwork: 'yellow',
      subgradeSupport: 'yellow',
      subgradeBridge: 'yellow',
      subgradeDrainage: 'yellow',
      bridge: 'red',
      trafficSafety: 'red',
      fileList: [],
      worldposition: { x: 393.48, y: -4149.05, z: 1 }
    }
  ],
  
  qualityData: {
    title: '质量问题情况',
    stats: {
      total: 32,
      serious: 0,
      rectified: 32,
      rectificationRate: '100.00%'
    },
    chart: {
      categories: ['路基土石方', '路基支档', '路基桥涵', '路基排水', '桥梁'],
      values: [6, 5, 8, 11, 0]
    }
  },
  safetyData: {
    title: '安全隐患情况',
    stats: {
      total: 45,  // C62项目的安全隐患总数
      highRisk: 18,
      mediumRisk: 45,
      lowRisk: 12,
      rectificationRate: '100.00%'
    },
    chart: {
      data: [
        { value: 18, name: '高空作业', color: '#ff6b6b' },
        { value: 12, name: '临时用电', color: '#ffd93d' },
        { value: 8, name: '消防设施', color: '#6bcfff' },
        { value: 5, name: '机械伤害', color: '#a855f7' },
        { value: 2, name: '其他隐患', color: '#00ffcc' }
      ]
    }
  },
  constructionData: {
    earthwork: 24,      // 土方
    labor: 101,            // 劳务
    latticeBeam: 7,     // 格构梁
    total: 132           // 共计
  },
  imageFolder: './Sources/173'
}
